<template>
  <v-card class="dialog-card">
    <ModalHeader
      helpFileName="EditUserModal"
      icon="mdi-account-edit"
      :modalTitle="'Edit User'"
      @close="emit('close')" />
    <v-card-text v-if="current_user_modal">
      <v-text-field
        label="Username"
        bg-color="var(--inner-background) !important"
        color="var(--text) !important"
        v-model="current_user_modal.username"></v-text-field>
      <v-text-field
        label="Email"
        bg-color="var(--inner-background) !important"
        color="var(--text) !important"
        v-model="current_user_modal.email"></v-text-field>
      <v-checkbox
        v-model="edit_password"
        label="Edit Password"
        hide-details></v-checkbox>
      <v-text-field
        v-if="edit_password"
        persistent-hint
        hint="More than 6 characters and contains 1 number or more"
        type="password"
        label="Password"
        bg-color="var(--inner-background) !important"
        color="var(--text) !important"
        v-model="current_user_modal.password"></v-text-field>
      <v-select
        label="Select"
        v-model="current_user_modal.role"
        :items="roleNames"></v-select>
    </v-card-text>

    <div class="modal-footer">
      <v-spacer />
      <v-btn
        style="width: 100%"
        :loading="save_loading"
        @click="SaveCurrentUser()"
        color="primary"
        variant="flat">
        <v-icon class="ml-1 mr-2">mdi-content-save</v-icon>
        Save
      </v-btn>
    </div>
  </v-card>
</template>
<script setup>
import { onMounted, ref, computed, defineProps } from 'vue';
import { $http } from '../../stores/http.js';
import { deluge } from '@/stores/deluge.js';
import HelpButton from '../Help-Hints/HelpButton.vue';
import ModalHeader from '../Shared/Modals/ModalHeader.vue';
const props = defineProps(['current_user', 'edit_user']);
const save_loading = ref(false);
const roleNames = computed(() =>
  Object.values(deluge.roles || {}).map((r) => r.name)
);
const edit_password = ref(false);
const current_user_modal = ref(undefined);
const emit = defineEmits(['close']);

onMounted(() => {
  // Clone props to avoid parent mutation
  current_user_modal.value = { ...props.current_user };
  current_user_modal.value.role =
    deluge.roles[current_user_modal.value.role].name;
});
// handleFocusOut() {
//     this.SaveCurrentUser();
// },
function SaveCurrentUser() {
  let pass = true;
  if (!current_user_modal.value.email) {
    pass = false;
    alert('An email is required');
  }
  if (!edit_password.value) {
    current_user_modal.value.password = null;
  } else {
    if (
      current_user_modal.value.password.length < 6 ||
      !/\d/.test(current_user_modal.value.password)
    ) {
      pass = false;
      alert('The password must contain at least 6 characters and one number');
    }
  }
  if (pass) {
    save_loading.value = true;
    $http(
      'PUT',
      '/edit_user?role=' + current_user_modal.value.role,
      JSON.stringify(current_user_modal.value)
    ).then((response) => {
      if (response === '"success"') {
        save_loading.value = false;
        emit('close');
      } else if (response === '"user exists"') {
        alert('user already exists!');
        save_loading.value = false;
      } else if (response === '"email exists"') {
        alert('email already registered to another account');
        save_loading.value = false;
      }
    });
  }
}
</script>
